import { EntityState } from '@ngrx/entity';
import { Order } from '@app/resources/services';

export interface OrderState extends EntityState<Order> {
  selectedOrderId: number | null;
  hasLoaded: boolean;
  orderQty: number;
}
